import { trackFbqEvent } from "./fbqEventFactory";
import { gAdsOnboardingConversionEvent } from "./gAdsFactory";
import { trackersFactory } from "./trackersFactory";

const trackers = trackersFactory("onboarding-page");

const submit = (): void => {
  gAdsOnboardingConversionEvent();
  trackers({ action: "submit-onboarding-complete" });
  trackFbqEvent("SubmitApplication");
};

export const trackOnboarding = {
  submit,
};
